if (!customElements.get('collection-hero')) {
  customElements.define('collection-hero', class extends HTMLElement {
    connectedCallback() {
      const text = this.querySelector('.card__text');
      const header = document.querySelector('body > header');
      this.observer = new ResizeObserver(() => {
        // Include the header, breadcrumbs and spacing above this hero.
        this.style.setProperty('--collection-hero-offset', `${this.getBoundingClientRect().top + window.scrollY}px`);
        this.style.setProperty('--collection-hero-text-height', `${text.offsetHeight}px`);
      });
      this.observer.observe(text);
      if (header) this.observer.observe(header);
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }
  });
}
